import React from "react";
import { Table, Checkbox } from "rsuite";

const CheckCell = ({
  rowData,
  onChange,
  checkedKeys,
  dataKey,
  ...props
}: {
  rowData?: any;
  onChange: any;
  checkedKeys: any;
  dataKey: string;
}) => {
  const { Cell } = Table;
  return (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: "46px" }}>
        <Checkbox
          value={rowData[dataKey]}
          inline
          onChange={onChange}
          style={{ margin: 0 }}
          checked={checkedKeys.some((item: any) => item === rowData[dataKey])}
        />
      </div>
    </Cell>
  );
};

export default CheckCell;
